export const isProd = () => {
    const { NODE_ENV } = process.env;
    return typeof NODE_ENV !== "undefined" &&
        NODE_ENV === `"production"`;
};
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/fx-schema-form-react/libs/utils.js
// module id = 71
// module chunks = 3